import { Paged } from './Misc';
import { User } from './User';
import { CustomFilterForm } from './CustomFilter';
import { OpMember } from './Member';

// eslint-disable-next-line import/prefer-default-export
export enum QueryGroup {
  All = 'ALL',
  Prep = 'PREP',
  Exec = 'EXEC',
  Cc = 'CC',
}

export enum Assigned {
  AllOp = 'AllOp',
  MyOp = 'MyOp',
  GroupOp = 'GroupOp',
}

export interface OperationFilterBase {
  queryGroup: string;
  assigned: string;
  subqueryType: string | null;
  subqueryId: number | null;
}

export interface OperationFilter extends OperationFilterBase {
  pageNumber: number;
  pageSize: number;
  sortDescending: boolean;
  sortField: string;
  hideColumns: string[];
  removeColumns: string[];
  customFilters?: CustomFilterForm | null;
  customFilterId?: number | null;
}

export interface OperationItem {
  id: number;
  number: string;
  name: string;
  typeModality: string;
  esgStatus: string;
  stage: string;
  phase: string;
  operationYear: string;
  lendingType: string;
  sectorSubSector: string;
  esic: string | null;
  dccrc: string | null;
  esrr: string | null;
  spr: string | null;
  sprDate: string | null;
  sprRationale: string | null;
  nextCommittee: string | null;
  teamLeader: string;
  groupName: string | null;
  primaryMember: string;
  esgMembers: string;

  assessmentsDisclosure: string;
  esgDocumentStatus: string;
  esgIndicators: string;

  nextMission: string;
  lastMission: string;
  approvalDate: string;
  idbAmount: number;
  totalProjectCost: number;
  percDisburstment: number;
  pmr: string;

  regionCountry: string;
  executingAgency: string;
  borrower: string;

  analysisMissionDate: string | null;
  closingDate: string | null;

  isReformulated: string | null;
  esicDate: string | null;
  espsPolicies: string | null;
  esrrDate: string | null;
  esrrRationale: string | null;

  previousEsrr: string | null;
  previousEsrrDate: string | null;
  previousEsrrRationale: string | null;
  qrrDate: string | null;
  ermDate: string | null;
  prevSpr: string | null;
  prevSprDate: string | null;
  prevSprRationale: string | null;
  miciCases: string | null;
  subSectorName: string | null;
  kickOffDate: string | null;
  m95DisbursedDate: string | null;

  ghgEmissionsOperation: string | null;
  ghgEmissionsConstruction: string | null;
  esgIndicatorsApply: number;
  coFinancing: string | null;
  frameworkApproach: string | null;
}

export interface OperationBasicItem {
  id: number;
  number: string;
  name: string;
  countryCode: string;
}

export interface Operation {
  id: number;
  number: string;
  name: string;
  stage: string;
  phase: string;
  subPhase: string;
  impact: string | null;
  esrr: string | null;
  disasterRisk: string | null;
  safeguardPerformance: string | null;
  loanNumber: string[] | null;
  memberList: OpMember[];
  primaryMember: User | null;
  groupCode: string;
  teamLeader: string;
  isMember: boolean;
  isEspf: boolean;
  indicatorsApply: boolean;
  invalidAssignments: boolean;
  memberRationales: Rationale[];
  userTaskDelegations: string[];
  belongsGS: boolean;
  relateds: OperationRelated[];
  esgStatus: string;
  miciCaseIds: number[];
  region: string;
  country: string;
  sector: string;
  subSector: string;
  borrower: string;
  executingAgencies: string;
  disbursed: number;
  idbAmount: number;
  totalProjectCost: number;
  lastDisbursmentDate: string | null;
  isReformulated: string | null;
  ezShareSiteUrl: string;
  lendingType: string;
  type: string;
  modality: string | null;
  subTypeCode: string | null;
  ghgConstruction: string | null;
  ghgOperation: string | null;
  frameworkApproach: string | null;
  coFinancing: string | null;
}

export interface OperationRelated {
  id: number;
  number: string;
}

export interface Rationale {
  id: number;
  name: string;
}

export interface OperationDocument {
  id: number;
  flowType: string;
  documentName: string;
  createdBy: string;
  createdOn: string;
  canDelete: boolean;
  source: string;
  ezShareDocumentCode: string;
}

export interface OperationMission {
  id: number;
  number: string;
  type: string;
  startDate: string;
  endDate: string | null;
  status: string | null;
  objective: string;
}

export interface OperationMiciCase {
  id: number;
  number: string;
  receiptDate: string;
  registerDate: string;
  status: string;
  stage: string;
}

export interface OperationGrievance {
  id: number;
  number: string;
  status: string;
  phase: string;
  registrationDate: string;
}

export interface DocumentFilter {
  operationId: number;
  pageNumber: number;
  sortDescending: boolean;
  sortField: string;
}

export interface MissionFilter {
  operationId: number;
  pageNumber: number;
  sortDescending: boolean;
  sortField: string;
  queryGroup: string | null;
}

export interface MiciCaseFilter {
  pageNumber: number;
  sortDescending: boolean;
  sortField: string;
  operationId?: number;
  queryGroup: string | null;
}
/*
export interface GrievanceFilter1 {
  pageNumber: number;
  sortDescending: boolean;
  sortField: string;
  operationId?: number;
  queryGroup: string | null;
} */

export interface Highlight {
  name: string;
  value: number;
  color: string;
}

export interface HighlightTooltip<T> extends Highlight {
  data: T;
}

export interface HighlightCategory {
  name: string;
  highlights: Highlight[];
}
export interface MemberGroup {
  id: number | null;
  name: string;
}

export interface CustomFilter {
  id: number;
  name: string;
  queryGroup: string | null;
  assigned: string | null;
}

export interface OperationList extends Paged<OperationItem> {
  highlightGroups: HighlightCategory[];
  memberGroups: MemberGroup[];
  customFilters: CustomFilter[];
  lastUpdateDate: string;
}

export type SearchOperationList = Paged<SearchOperationItem>;

export interface SearchOperationItem {
  number: string;
  name: string;
  description: string;
  type: string;
  modifiedDate: string;
}

export interface OperationContextType {
  operation: Operation;
  loading: boolean;
  reload: (f?: string) => void;
}
